import { UndoOutlined } from "@ant-design/icons";
import {
  Button,
  Table,
  Tooltip,
  Tag,
  Input,
  Image,
  Card,
  Pagination,
  Drawer,
  Modal,
  Row,
  Col,
  Divider,
  Descriptions,
  Select,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Plus from "../../assets/images/plus.svg";
import ConfirmationBox from "../../components/ConfirmationBox";
import DeleteModal from "../../components/DeleteModal";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import AddForm from "./AddForm";

const { Option } = Select;

function Index() {
  const heading = lang("Sport Category") + " " + lang("Management");
  const { setPageHeading } = useContext(AppStateContext);

  const sectionName = "Category";
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");

  const api = {
    list: apiPath.CategoryList,
    addEdit: apiPath.CategoryAddEdit,
    statusChange: apiPath.CategoryStatusChanges,
    delete: apiPath.categoryDelete,
  };

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const { showConfirm } = ConfirmationBox();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);

  const onDelete = (id) => {
    request({
      url: api.delete + "/" + id,
      method: "POST",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast("Category Deleted Successfully", Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id) => {
    request({
      url: api.statusChange + "/" + id,
      method: "PUT",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newList = Array.from(list);
    const [movedItem] = newList.splice(result.source.index, 1);
    newList.splice(result.destination.index, 0, movedItem);

    setList(newList);

    const reorderedPayload = newList.map((item, index) => ({
      _id: item._id,
      priority: index + 1,
    }));

    request({
      url: apiPath.updatePriorityBulk,
      method: "POST",
      data: { categories: reorderedPayload },
      onSuccess: () => ShowToast("Category order updated!", Severty.SUCCESS),
      onError: () => ShowToast("Something went wrong", Severty.ERROR),
    });
  };

  // const columns = [
  //   {
  //     title: "Image",
  //     dataIndex: "image",
  //     key: "image",
  //     render: (_, { image }) => (
  //       <Image
  //         src={image}
  //         alt="banner"
  //         width={80}
  //         height={40}
  //         style={{
  //           objectFit: "cover",
  //           borderRadius: 6,
  //           border: "1px solid #eee",
  //         }}
  //         preview={{ mask: "Preview" }}
  //       />
  //     ),
  //   },
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //     key: "name",
  //     render: (_, { name }) => {
  //       return name ? name : "-";
  //     },
  //   },
  //   {
  //     title: "Status",
  //     key: "is_active",

  //     filters: [
  //       {
  //         text: "Active",
  //         value: true,
  //       },
  //       {
  //         text: "Inactive",
  //         value: false,
  //       },
  //     ],
  //     render: (_, { is_active, _id }) => {
  //       let color = is_active ? "green" : "red";
  //       return (
  //         <a>
  //           <Tag
  //             onClick={(e) =>
  //               showConfirm({
  //                 record: _id,
  //                 path: api.statusChange,
  //                 onLoading: () => setLoading(true),
  //                 onSuccess: () => {
  //                   setRefresh((prev) => !prev);
  //                   ShowToast(
  //                     `Status changed to ${
  //                       !is_active ? "Active" : "Inactive"
  //                     } successfully`,
  //                     Severty.SUCCESS
  //                   );
  //                 },
  //               })
  //             }
  //             color={color}
  //             key={is_active}
  //           >
  //             {is_active ? "Active" : "Inactive"}
  //           </Tag>
  //         </a>
  //       );
  //     },
  //   },
  //   {
  //     title: "Added Date",
  //     key: "created_at",
  //     dataIndex: "created_at",
  //     render: (_, { created_at }) => {
  //       return moment(created_at).format("ll");
  //     },
  //   },
  //   {
  //     title: "Action",
  //     fixed: "right",
  //     key: "action",
  //     render: (_, record) => {
  //       return (
  //         <div div className="d-flex justify-contenbt-start">
  //           <Tooltip title={"Edit"} color={"purple"} key={"edit"}>
  //             <Button
  //               className="edit-cls btnStyle primary_btn"
  //               onClick={() => {
  //                 setSelected(record);
  //                 setVisible(true);
  //               }}
  //             >
  //               <i class="fas fa-edit"></i>
  //               {/* <span>Edit</span> */}
  //             </Button>
  //           </Tooltip>
  //           <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
  //             <Button
  //               title="Delete"
  //               className="btnStyle deleteDangerbtn"
  //               onClick={() => {
  //                 setSelected(record);
  //                 setShowDelete(true);
  //               }}
  //             >
  //               <i class="fas fa-trash"></i>
  //             </Button>
  //           </Tooltip>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  useEffect(() => {
    setLoading(true);
    fetchData({ ...pagination, current: 1 });
  }, [refresh, debouncedSearchText, startDate, endDate, statusFilter]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters) => {
    request({
      url: `${api.list}?page=${pagination ? pagination.current : 1}&pageSize=${
        pagination ? pagination.pageSize : 10
      }&search=${debouncedSearchText}&status=${statusFilter || ""}&start_date=${
        startDate ? startDate : ""
      }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: ({ data, status, total, message }) => {
        setLoading(false);
        if (status) {
          setList(data?.list?.docs || []);
          setPagination({
            current: data?.list?.page,
            total: data?.list?.totalDocs,
            pageSize: data?.list?.limit,
          });
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };
  const handleStatusFilterChange = (value) => {
    setStatusFilter(value);
  };

  return (
    <>
      <Card
        title="Sport Category List"
        extra={
          <>
            <div className="d-flex align-items-center gap-3 text-head_right_cont">
              <div className="pageHeadingSearch d-flex gap-2">
                <Input.Search
                  className="searchInput searchInput-new-main"
                  placeholder="Search By Name"
                  onChange={onSearch}
                  value={searchText}
                  allowClear
                />
                <Select
                  placeholder="Filter by Status"
                  style={{ width: 150 }}
                  onChange={handleStatusFilterChange}
                  // value={statusFilter}
                  allowClear
                >
                  <Option value="true">Active</Option>
                  <Option value="false">Inactive</Option>
                </Select>
                <Button
                  className="primary_btn btnStyle"
                  onClick={(e) => {
                    setVisible(true);
                    setSearchText("");
                  }}
                >
                  <span className="add-Ic">
                    <img src={Plus} />
                  </span>
                  {sectionName}
                </Button>
              </div>
            </div>
          </>
        }
      >
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="category-list">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {list.map((item, index) => (
                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="drag-item"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: 12,
                          marginBottom: 8,
                          border: "1px solid #ddd",
                          borderRadius: 6,
                          background: "#fff",
                          ...provided.draggableProps.style,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Image
                            src={item.image}
                            alt="category"
                            width={50}
                            height={50}
                            style={{
                              objectFit: "cover",
                              borderRadius: 50,
                              border: "1px solid #eee",
                            }}
                          />
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <strong>
                                {item.name
                                  ?.toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )}
                              </strong>

                              <div>
                                <Tag
                                  color={item.is_active ? "green" : "red"}
                                  className="new-active-class-main"
                                  onClick={() =>
                                    showConfirm({
                                      record: item._id,
                                      path: api.statusChange,
                                      onLoading: () => setLoading(true),
                                      onSuccess: () => {
                                        setRefresh((prev) => !prev);
                                        ShowToast(
                                          `Status changed to ${
                                            !item.is_active
                                              ? "Active"
                                              : "Inactive"
                                          } successfully`,
                                          Severty.SUCCESS
                                        );
                                      },
                                    })
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {item.is_active ? "Active" : "Inactive"}
                                </Tag>
                              </div>
                            </div>
                            <div
                              style={{
                                fontSize: 12,
                                color: "#777",
                                fontWeight: "700",
                              }}
                            >
                              Added: {moment(item.created_at).format("ll")}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-2">
                          <Tooltip title="View Details" color="purple">
                            <Button
                              className="btnStyle info_btn"
                              onClick={() => {
                                setSelected(item);
                                setDetailsVisible(true);
                              }}
                            >
                              <i className="fas fa-eye" />
                            </Button>
                          </Tooltip>

                          <Tooltip title="Edit" color="purple">
                            <Button
                              className="btnStyle primary_btn"
                              onClick={() => {
                                setSelected(item);
                                setVisible(true);
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </Button>
                          </Tooltip>

                          <Tooltip title="Delete" color="purple">
                            <Button
                              className="btnStyle deleteDangerbtn"
                              onClick={() => {
                                setSelected(item);
                                setShowDelete(true);
                              }}
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className="d-flex justify-content-end mt-3 customPagination">
          <Pagination
            current={pagination.current}
            total={pagination.total}
            pageSize={pagination.pageSize}
            showSizeChanger
            onChange={(page, pageSize) => {
              setPagination((prev) => ({ ...prev, current: page, pageSize }));
              fetchData({ current: page, pageSize });
            }}
            pageSizeOptions={["10", "20", "50", "100"]}
          />
        </div>
      </Card>
      <Modal
        className="tab_modal tab_modal-close"
        open={detailsVisible}
        footer={null}
        closable={true}
        width={800}
        onCancel={() => {
          setSelected(null);
          setDetailsVisible(false);
        }}
      >
        <h4 className="modal_title_cls"> Category Details</h4>
        {selected && (
          <div className="category-details-modal" style={{ padding: 16 }}>
            <Descriptions
              bordered
              column={1}
              size="middle"
              labelStyle={{ fontWeight: 500 }}
              contentStyle={{ fontSize: 14 }}
            >
              <Descriptions.Item label="Name">
                {selected.name}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                <Tag
                  color={selected.is_active ? "green" : "red"}
                  style={{ fontWeight: 600 }}
                >
                  {selected.is_active ? "Active" : "Inactive"}
                </Tag>
              </Descriptions.Item>

              <Descriptions.Item label="Created At">
                {moment(selected.created_at).format("LL")}
              </Descriptions.Item>
              <Descriptions.Item label="Priority">
                {selected.priority}
              </Descriptions.Item>

              <Descriptions.Item label="Quiz Count">
                {selected.quiz_count || 0}
              </Descriptions.Item>
            </Descriptions>

            <Divider orientation="left">
              <strong>Assigned Quizzes</strong>
            </Divider>

            {selected.quizzes?.length > 0 ? (
              <Table
                dataSource={selected.quizzes}
                rowKey="_id"
                pagination={false}
                bordered
                size="middle"
                columns={[
                  {
                    title: "Title",
                    dataIndex: "title",
                    key: "title",
                    render: (title) => <strong>{title}</strong>,
                  },
                  {
                    title: "Fees",
                    dataIndex: "fees",
                    key: "fees",
                    align: "center",
                    render: (fees) => (
                      <span style={{ fontWeight: 500 }}>₦{fees}</span>
                    ),
                  },
                  // {
                  //   title: "Action",
                  //   key: "action",
                  //   align: "center",
                  //   render: (_, quiz) => (
                  //     <div className="d-flex justify-content-center gap-2">
                  //       <Tooltip title="View Quiz">
                  //         <Button
                  //           type="link"
                  //           icon={<i className="fas fa-eye" />}
                  //         />
                  //       </Tooltip>
                  //     </div>
                  //   ),
                  // },
                ]}
              />
            ) : (
              <div className="text-muted mt-2">No quizzes assigned.</div>
            )}
          </div>
        )}
      </Modal>

      {visible && (
        <AddForm
          api={api}
          show={visible}
          hide={() => {
            setVisible(false);
            setSelected(null);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {showDelete && (
        <DeleteModal
          title="Delete Category"
          subtitle="Are you sure you want to delete this category?"
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected(null);
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
}

export default Index;
